'use strict';

'use strict';

const accordion = document.querySelectorAll('.accordion .accordion__item');

accordion.forEach((accordion_item) => {
    const title = accordion_item.querySelector( '.accordion__title' );

    title.addEventListener('click', function () {

        accordion.forEach((this_item) => {
            const description = this_item.querySelector( '.accordion__description' );
            if ( this_item === accordion_item ) {

                if ( !this_item.classList.contains( 'is-active' ) ) {
                    this_item.classList.add( 'is-active' );
                    description.style.height = 'auto';
                    const height = description.offsetHeight;
                    description.style.height = '0';
                    setTimeout(() => {
                        description.style.height = height + 'px';
                    }, 10);
                }else{
                    this_item.classList.remove( 'is-active' );
                    description.style.height = '0';
                }

            }else {
                this_item.classList.remove( 'is-active' );
                description.style.height = '0px';
            }
        });
        
    });
});
